// extracted by mini-css-extract-plugin
export default {"appBtn":"Banner_appBtn__PeQqB","brown":"Banner_brown__EVW-2","flex":"Banner_flex__to7bO","btns":"Banner_btns__B7ZF2","banner":"Banner_banner__KRWo2"};